import { ChordProRenderer } from "@bandwith/songs";
import { ChordProEditor } from "./ChordProEditor";

/**
 * Side-by-side ChordPro editor and live preview panes.
 * `previewContent` should be debounced by the caller to avoid
 * re-rendering the preview on every keystroke.
 */
export function ChordProEditPane({
  value,
  onChange,
  onSubmit,
  disabled,
  previewContent,
  showChords,
}: {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  disabled: boolean;
  previewContent: string;
  showChords: boolean;
}) {
  return (
    <div className="flex flex-col gap-4 lg:w-[min(200%,100vw)] lg:flex-row">
      {/* Editor pane */}
      <div className="relative min-w-0 flex-1 lg:w-1/2 lg:flex-none">
        <span className="mb-2 block font-mono text-xs uppercase tracking-widest text-text-muted">
          ChordPro
        </span>
        <ChordProEditor
          value={value}
          onChange={onChange}
          onSubmit={onSubmit}
          disabled={disabled}
        />
      </div>
      {/* Live preview pane */}
      <div className="min-w-0 flex-1">
        <span className="mb-2 block font-mono text-xs uppercase tracking-widest text-text-muted">
          Preview
        </span>
        <div className="rounded-lg border border-border-subtle bg-bg-secondary p-5">
          <ChordProRenderer content={previewContent} showChords={showChords} />
        </div>
      </div>
    </div>
  );
}
